import { bianka, BIANKA_ACTIVITY_TYPES, logger } from '@fiverr-private/obs';
import { Impression } from '@fiverr-private/bianka_js';
import { TailoredHomepage } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/tailored_homepage_component';
import { IImpressionData, EnrichedImpressionData } from '@fiverr-private/homepage_common_types';
import { ProfessionCardComponent } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v1/extension/profession_card_component';
import { getContext } from '@fiverr-private/fiverr_context';
import { buildProfessionCardAttributes, buildProfessionCardSeller } from './utils';
import { IMPRESSION } from './constants';

export const sendImpressionEvent = async (impressionData: IImpressionData) => {
    try {
        const { pageCtxId } = getContext();

        void bianka.reportActivity<Impression, TailoredHomepage>({
            event: {
                type: IMPRESSION.EVENT_TYPE,
                page: {
                    ctxId: pageCtxId,
                    name: 'tailored_home_page',
                },
                component: {
                    name: impressionData.componentName,
                    type: impressionData.componentType,
                    impId: impressionData.imp_id,
                    isLeaf: impressionData.is_leaf,
                    level: impressionData.level,
                    positionInParent: impressionData.position_in_parent,
                    sizeInParent: impressionData.size_in_parent,
                    visibleThroughScroll: impressionData.visible_through_scroll,
                    parentComponentImpId: impressionData.parent_component_imp_id,
                    location: {
                        topYAxis: impressionData.location.top_y_axis,
                    },
                },
            },
            additionalData: {
                message: {
                    tailoredHomepageAttributes: {
                        layoutId: impressionData.layoutId,
                        buyerState: impressionData.buyerState,
                        primary: {
                            size: impressionData.primarySize,
                        },
                        tabbedCarousel: {
                            firstTabAsset: impressionData.first_tab_asset,
                            firstTabLogic: impressionData.first_tab_logic,
                            shownTabs: impressionData.shown_tabs || [],
                        },
                    },
                    inboxMessage: impressionData.inboxMessage,
                    order: impressionData.order,
                },
                type: TailoredHomepage,
            },
            type: BIANKA_ACTIVITY_TYPES.IMPRESSION,
        });
    } catch (error: any) {
        logger.error(error, { description: 'Failed to send impression' });
    }
};

export const onImpression = async (impressionData: EnrichedImpressionData) => {
    try {
        await sendImpressionEvent(impressionData);
    } catch (error: any) {
        logger.error(error, {
            description: `Failed to send impression: Component - ${impressionData.componentName} `,
            impressionData,
        });
    }
};

export const onCardImpression = async (eventData: any) => {
    try {
        const { ...component } = eventData;
        const { pageCtxId } = getContext();

        const eventPayload = {
            type: BIANKA_ACTIVITY_TYPES.IMPRESSION,
            event: {
                type: IMPRESSION.EVENT_TYPE_ROLE_CARD,
                group: IMPRESSION.GROUP,
                page: {
                    ctxId: pageCtxId,
                    name: 'tailored_home_page',
                },
                component: {
                    name: component?.name,
                    positionInParent: component?.position_in_parent,
                    impId: component?.imp_id,
                    parentComponentImpId: component?.parent_component_imp_id,
                    level: component?.level,
                    isLeaf: component?.is_leaf,
                    sizeInParent: component?.size_in_parent,
                    location: { topYAxis: component.location?.top_y_axis },
                    visibleThroughScroll: component?.visible_through_scroll,
                },
            },
            additionalData: {
                message: {
                    professionCardAttributes: buildProfessionCardAttributes(
                        component?.profession_card?.profession_card_attributes
                    ),
                    seller: buildProfessionCardSeller(component?.profession_card?.seller),
                },
                type: ProfessionCardComponent,
            },
        };

        void bianka.reportActivity<Impression, ProfessionCardComponent>(eventPayload);
    } catch (error: any) {
        logger.error(error, { description: 'Failed to send onCardImpression' });
    }
};

export { IImpressionData };
